document.addEventListener("DOMContentLoaded", function () {
  const countdownSection = document.querySelector('.el-countdown-timer');
  const finalDate = new Date(
    countdownSection.dataset.countdownDate
  );

  function updatetimercount1() {
    const now = new Date();
    const timeDifference = finalDate - now;

    if (timeDifference > 0) {
      const dayss = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      const hourss = Math.floor(
        (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutess = Math.floor(
        (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
      );
      const secondss = Math.floor(
        (timeDifference % (1000 * 60)) / 1000
      );

      document.getElementById('countdown_days').innerHTML = dayss;
      document.getElementById('countdown_hours').innerHTML = hourss;
      document.getElementById('countdown_minutes').innerHTML = minutess;
      document.getElementById('countdown_seconds').innerHTML = secondss;

      setTimeout(updatetimercount1, 1000);
    } else {
      document.getElementById('el-countdown-timer-1').style.display = 'none';
      document.getElementById('el-countdown-timer__expired-1').style.display = 'block';
    }
  }

  updatetimercount1();
});